export default __webpack_public_path__ + "header-image-480-92d1ecf9f698a6dee62636b89d793122.png";